import baseAPI from './baseAPI'

const getOrderStatus = async () => {
    return await baseAPI.get('order/orderstatus')
}

export default {
    getOrderStatus,
}